import { Button, Grid } from "@mui/material";
import { STATE_LIST } from "../../../../constants";
import { ProviderUserType } from "../../../../constants/ProviderUserSchema";
import { Formik } from "../../../../utils/formikHelpers";
import CustomDatePicker from "../../../CustomDatePicker";
import CustomSelect from "../../../CustomSelect";
import Flex from "../../../Flex";
import Input from "../../../Input";
import Text from "../../../Text";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { useEffect } from "react";

interface DeaInformationProps {
  formik: Formik<ProviderUserType>;
}

const DeaInformation = ({ formik }: DeaInformationProps) => {
  useEffect(() => {
    if (!formik.values?.deaInformation?.length) addHandler();
  }, [formik.values?.deaInformation]);

  function deleteById(id: number) {
    formik.setFieldValue(
      "deaInformation",
      formik.values?.deaInformation?.filter((_, index: any) => {
        return index + 1 !== id;
      })
    );
  }

  function addHandler() {
    // formik.validateForm().then((errors) => {
    //   const hasErrors = Object.keys(errors.licenceInformation ?? {}).length > 0;
    //   if (!hasErrors) {
    formik.setFieldValue("deaInformation", [
      ...(formik.values?.deaInformation ?? []),
      {
        deaState: "",
        deaNumber: "",
        deaTermDate: "",
        deaActiveDate: "",
      },
    ]);
    //   })
    //    else {
    //     formik.setFieldTouched("licenceInformation", true);
    //     formik.values.licenceInformation.forEach((_, index) => {
    //       formik.setFieldTouched(
    //         `licenceInformation.${index}.licenseState`,
    //         true
    //       );
    //       formik.setFieldTouched(
    //         `licenceInformation.${index}.licenseNumber`,
    //         true
    //       );
    //       formik.setFieldTouched(
    //         `licenceInformation.${index}.expiryDate`,
    //         true
    //       );
    //     });
    //   }
    // });
  }

  return (
    <>
      <Flex
        justifyContent={"space-between"}
        width={"100%"}
        alignItems={"center"}
      >
        <Text fontWeight={"medium"}>DEA Information</Text>
        <Button
          onClick={addHandler}
          startIcon={<AddCircleOutlineRoundedIcon />}
        >
          Add New
        </Button>
      </Flex>

      {formik.values?.deaInformation?.map((ele, ind) => (
        <Grid container spacing={2} mb={"10px"} key={ind}>
          <Grid item xs={3} lg={3} xl={3}>
            <CustomSelect
              label="State"
              name="deaState"
              options={STATE_LIST}
              value={ele?.deaState}
              onChange={(option) => {
                formik.setFieldValue(`deaInformation[${ind}].deaState`, option);
              }}
              //   onChange={(option) => formik.setFieldValue("new_patient", option)}
            />
          </Grid>
          <Grid item xs={3} lg={3} xl={3}>
            <Input
              label="DEA Number"
              textFieldProps={{
                placeholder: "Enter Number",
                onChange: (e) => {
                  formik.setFieldValue(
                    `deaInformation[${ind}].deaNumber`,
                    e.currentTarget.value
                  );
                },
                value: ele?.deaNumber,
              }}
            />
          </Grid>
          <Grid item xs={3} lg={3} xl={3}>
            <CustomDatePicker
              label="DEA Active Date"
              value={ele?.deaActiveDate}
              onChange={(val) => {
                formik.setFieldValue(
                  `deaInformation[${ind}].deaActiveDate`,
                  val
                );
                formik.setFieldTouched(
                  `deaInformation[${ind}].deaActiveDate`,
                  true,
                  false
                );
              }}
              error={
                (formik.touched as any)?.deaInformation?.[ind]?.deaActiveDate &&
                (formik.errors as any)?.deaInformation?.[ind]?.deaActiveDate
              }
            />
          </Grid>
          <Grid item xs={3} lg={3} xl={3}>
            <Flex gap={1} flex={1}>
              <CustomDatePicker
                label="DEA Expiry Date"
                value={ele?.deaTermDate}
                onChange={(val) => {
                  formik.setFieldValue(
                    `deaInformation[${ind}].deaTermDate`,
                    val
                  );
                  formik.setFieldTouched(
                    `deaInformation[${ind}].deaActiveDate`,
                    true,
                    false
                  );
                }}
              />
              <DeleteOutlineOutlinedIcon
                sx={{
                  marginTop: "5px",
                  cursor: "pointer",
                }}
                color={ind === 0 ? "disabled" : "error"}
                onClick={() => {
                  if (ind !== 0) {
                    deleteById(ind + 1);
                  }
                }}
              />
            </Flex>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default DeaInformation;
